import {mdiPlusCircleOutline} from '@mdi/js'
import clsx from 'clsx'
import type {MouseEvent} from 'react'
import {Button} from 'swayok-react-mdb-ui-kit/components/Button/Button'
import {IconButton} from 'swayok-react-mdb-ui-kit/components/Icon/IconButton'
import {useEventCallback} from 'swayok-react-mdb-ui-kit/helpers/useEventCallback'
import {NavigationService} from 'swayok-react-mdb-ui-kit/services/NavigationService'
import {appUrl} from '../../../AppUrl'
import {trans} from '../../../helpers'
import {useUserData} from '../../../hooks'
import {useAuthStore} from '../../../stores'

interface TopNavigationCreateAdButtonProps {
    forDropdownMenu?: boolean
    asIcon?: boolean
    className?: string
}

// Кнопка "Разместить объявление" в верхнем меню навигации.
export function TopNavigationCreateAdButton(props: TopNavigationCreateAdButtonProps) {
    const {
        forDropdownMenu = false,
        asIcon = false,
        className,
    } = props

    const user = useUserData()
    const setOnRegistrationSuccess = useAuthStore(
        state => state.setOnRegistrationSuccess
    )
    const initUserAuthModal = useAuthStore(
        state => state.initUserAuthModal
    )

    const url = appUrl().cabinet.ads.create
    const label = trans().common.top_navigation.add_advertisement

    // Открывает модальное окно авторизации.
    // После авторизации или регистрации переходит на страницу создания объявления.
    const showLoginModal = useEventCallback((
        event: MouseEvent
    ) => {
        event.preventDefault()
        setOnRegistrationSuccess(() => {
            NavigationService.navigate(url)
            return 'stop'
        })
        initUserAuthModal(() => NavigationService.navigate(url))
    })

    // Отобразить в виде иконки для размещения внутри .dropdown-item.
    if (asIcon) {
        return (
            <IconButton
                path={mdiPlusCircleOutline}
                color="green"
                tooltip={label}
                onClick={event => {
                    // Отменяем событие, чтобы отключить перенаправление в DropdownItem.
                    event.preventDefault()
                    event.stopPropagation()
                    if (user) {
                        NavigationService.navigate(url)
                    } else {
                        showLoginModal(event)
                    }
                }}
            />
        )
    }

    const permanentClassName = forDropdownMenu
        ? 'text-nowrap full-width'
        : 'top-nav-add-listing-btn lh-1 flex-shrink-0 flex-center fw-700'

    return (
        <Button
            color="blue"
            className={clsx(permanentClassName, className)}
            href={url}
            onClick={user ? undefined : showLoginModal}
        >
            {label}
        </Button>
    )
}
